import { render, staticRenderFns } from "./AMHeader.vue?vue&type=template&id=46b88122&scoped=true"
import script from "./AMHeader.vue?vue&type=script&lang=js"
export * from "./AMHeader.vue?vue&type=script&lang=js"
import style0 from "./AMHeader.vue?vue&type=style&index=0&id=46b88122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b88122",
  null
  
)

export default component.exports